import React from 'react';
import SingleService from '../../../components/SingleService/SingleService';
import ServicesData from '../../../data/servicesData';

const HomeServices = () => {
   return (
      <>
         <section className="services__area pt-115 pb-80">
            <div className="tw-container tw-mx-auto">
               <div className="tw-flex tw-flex-wrap tw--mx-3">
                  <div className="tw-w-full tw-px-3 lg:tw-w-10/12 lg:tw-ml-[4.1667%] xl:tw-w-8/12 xl:tw-ml-[16.6667%]">
                     <div className="section__title section__title-3 tw-text-center mb-90 wow fadeInUp" data-wow-delay=".2s">
                        <span>Build &rarr; Design &rarr; Automate &rarr; Grow</span>
                        <h2>Everything you need to build and grow your digital product.</h2>
                     </div>
                  </div>
               </div>
               <div className="tw-flex tw-flex-wrap tw--mx-3">
                  {ServicesData.map((service) => (
                     <SingleService key={service.id} icon={service.icon} title={service.title} content={service.content} link={service.link} />
                  ))}
               </div>
            </div>
         </section>
      </>
   );
};

export default HomeServices;
